import { CDN } from "../enums/CDN";
import { Country } from "../model/Country";
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("WorldAssignment.CountryXMLParser");

export const parseCountries = (object: any): Array<Country> => {

    let parser = new DOMParser();
    let doc: Document = parser.parseFromString(object, "text/xml");
    let countries: Country[] = [];
    let country: Country;
    let countriesElement: Element = doc.querySelector("countries");

    if (!countriesElement) {
        logger.debug("node 'countries' not found");
        return [];
    }

    if (countriesElement.children && countriesElement.children.length) {
        for (let i = 0; i < countriesElement.children.length; i++) {
            country = parseCountry(countriesElement.children.item(i));
            countries.push(country);
        }
    } else {
        logger.debug("node 'countries' is null or empty");
    }

    return countries;
}

const parseCountry = (element: Element): Country => {
    let item: any;
    let attr: Attr;

    item = element.querySelector("country");
    let countryString: string = item ? item.textContent : "";

    item = element.querySelector("lang");
    let lang: string = item ? item.textContent : "";

    item = element.querySelector("browserCodes");
    let browserCodes: string = item ? item.textContent : "";

    item = element.querySelector("geoIpCodes");
    let geoIpCodes: string = item ? item.textContent : "";

    item = element.querySelector("flashCode");
    let flashCode: string = item ? item.textContent : "";

    item = element.querySelector("timezoneStart");
    let timezoneStart: string = item ? item.textContent : "";

    item = element.querySelector("timezoneEnd");
    let timezoneEnd: string = item ? item.textContent : "";

    item = element.querySelector("np");
    let np: string = item ? item.textContent : "";

    attr = element.attributes.getNamedItem("default");
    let isDefault: boolean = attr ? attr.textContent === "1" : false;


    const country = new Country(
        countryString,
        lang,
        parseLanguageCodeList(browserCodes),
        parseLanguageCodeList(geoIpCodes),
        parseLanguageCodeList(flashCode),
        parseFloat(timezoneStart),
        parseFloat(timezoneEnd),
        parseCDN(np),
        isDefault)

    return country;
}

/**
 * Parses a list of languages codes. Either used for browser, flash or geoIp language codes
 * @param codes Expecting comma separated codes in square brackets, e.g. "[be_FR,be_NL]" or "[AU,NZ]" (or simply "pt" for fallback purposes)
 */
const parseLanguageCodeList = (codes: string): string[] => {
    let languageCodes: string[] = [];

    if (codes !== "") {
        // Example for languages code from XML: [da,da-DK]. Cut off the "[" and "]"
        let findOpeningSquareBrace: RegExp = /\[/;
        let findClosingSquareBrace: RegExp = /\]/;
        codes = codes.replace(findOpeningSquareBrace, "");
        codes = codes.replace(findClosingSquareBrace, "");

        // Separate codes
        let codeArr: any[] = codes.split(",");

        // Add codes
        for (let code of codeArr) {
            languageCodes.push(code.trim());
        }
    }

    return languageCodes;
}


const parseCDN = (shortcut: string): CDN => {
    switch (shortcut) {
        case "fb":
            return CDN.Fallback;
        case "ak":
            return CDN.Akamai;
        case "cd":
            return CDN.CDNetworks;
        case "cl":
            return CDN.Cloudfront;
        case "ll":
            return CDN.Limelight;
        default:
            return CDN.None;
    }
}

